import { render, staticRenderFns } from "./h-button-options-group.vue?vue&type=template&id=10b81dc0&scoped=true"
import script from "./h-button-options-group.vue?vue&type=script&lang=js"
export * from "./h-button-options-group.vue?vue&type=script&lang=js"
import style0 from "./h-button-options-group.vue?vue&type=style&index=0&id=10b81dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b81dc0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HLabel: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/forms/h-label.vue').default,HSvgIcon: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/icons/h-svg-icon.vue').default})
